__turbopack_context__.v({
  "manageFXAItem": "GRFokG_manageFXAItem",
  "menuItemCta": "GRFokG_menuItemCta",
  "menuItemWrapper": "GRFokG_menuItemWrapper",
  "menuList": "GRFokG_menuList",
  "trigger": "GRFokG_trigger",
});
